"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifierParametersSection = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var DropdownSectionHeader_1 = require("../DropdownSectionHeader");
var ProjectIdParameterDetail_1 = require("../ParameterDetails/ProjectIdParameterDetail");
var DashboardIdParameterDetail_1 = require("../ParameterDetails/DashboardIdParameterDetail");
var WidgetIdParameterDetail_1 = require("../ParameterDetails/WidgetIdParameterDetail");
var InsightIdParameterDetail_1 = require("../ParameterDetails/InsightIdParameterDetail");
var ClientIdParameterDetail_1 = require("../ParameterDetails/ClientIdParameterDetail");
var DataProductIdParameterDetail_1 = require("../ParameterDetails/DataProductIdParameterDetail");
var Parameter_1 = require("./Parameter");
var model_1 = require("../../../../../model");
var identifierParametersMessages = react_intl_1.defineMessages({
    insightIdParameterLabel: { id: "configurationPanel.drillIntoUrl.editor.insightIdParameterLabel" },
    widgetIdParameterLabel: { id: "configurationPanel.drillIntoUrl.editor.widgetIdParameterLabel" },
    dashboardIdParameterLabel: { id: "configurationPanel.drillIntoUrl.editor.dashboardIdParameterLabel" },
    projectIdParameterLabel: { id: "configurationPanel.drillIntoUrl.editor.projectIdParameterLabel" },
    workspaceIdParameterLabel: { id: "configurationPanel.drillIntoUrl.editor.workspaceIdParameterLabel" },
    clientIdParameterLabel: { id: "configurationPanel.drillIntoUrl.editor.clientIdParameterLabel" },
    dataProductIdParameterLabel: { id: "configurationPanel.drillIntoUrl.editor.dataProductIdParameterLabel" },
});
var identifierParametersSection = [
    {
        titleIntlKey: identifierParametersMessages.insightIdParameterLabel.id,
        placeholder: model_1.DRILL_TO_URL_PLACEHOLDER.INSIGHT_ID,
    },
    {
        titleIntlKey: identifierParametersMessages.widgetIdParameterLabel.id,
        placeholder: model_1.DRILL_TO_URL_PLACEHOLDER.WIDGET_ID,
    },
    {
        titleIntlKey: identifierParametersMessages.dashboardIdParameterLabel.id,
        placeholder: model_1.DRILL_TO_URL_PLACEHOLDER.DASHBOARD_ID,
    },
    {
        titleIntlKey: identifierParametersMessages.projectIdParameterLabel.id,
        placeholder: model_1.DRILL_TO_URL_PLACEHOLDER.PROJECT_ID,
    },
    {
        titleIntlKey: identifierParametersMessages.workspaceIdParameterLabel.id,
        placeholder: model_1.DRILL_TO_URL_PLACEHOLDER.WORKSPACE_ID,
    },
    {
        titleIntlKey: identifierParametersMessages.clientIdParameterLabel.id,
        placeholder: model_1.DRILL_TO_URL_PLACEHOLDER.CLIENT_ID,
    },
    {
        titleIntlKey: identifierParametersMessages.dataProductIdParameterLabel.id,
        placeholder: model_1.DRILL_TO_URL_PLACEHOLDER.DATA_PRODUCT_ID,
    },
];
var getDetailContent = function (type, title) {
    switch (type) {
        case model_1.DRILL_TO_URL_PLACEHOLDER.PROJECT_ID:
        case model_1.DRILL_TO_URL_PLACEHOLDER.WORKSPACE_ID:
            return react_1.default.createElement(ProjectIdParameterDetail_1.ProjectIdParameterDetail, { title: title });
        case model_1.DRILL_TO_URL_PLACEHOLDER.DASHBOARD_ID:
            return react_1.default.createElement(DashboardIdParameterDetail_1.DashboardIdParameterDetail, { title: title });
        case model_1.DRILL_TO_URL_PLACEHOLDER.WIDGET_ID:
            return react_1.default.createElement(WidgetIdParameterDetail_1.WidgetIdParameterDetail, { title: title });
        case model_1.DRILL_TO_URL_PLACEHOLDER.INSIGHT_ID:
            return react_1.default.createElement(InsightIdParameterDetail_1.InsightIdParameterDetail, { title: title });
        case model_1.DRILL_TO_URL_PLACEHOLDER.CLIENT_ID:
            return react_1.default.createElement(ClientIdParameterDetail_1.ClientIdParameterDetail, { title: title });
        case model_1.DRILL_TO_URL_PLACEHOLDER.DATA_PRODUCT_ID:
            return react_1.default.createElement(DataProductIdParameterDetail_1.DataProductIdParameterDetail, { title: title });
        default:
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.IdentifierParametersSection = function (_a) {
    var enableClientIdParameter = _a.enableClientIdParameter, enableDataProductIdParameter = _a.enableDataProductIdParameter, enableWidgetIdParameter = _a.enableWidgetIdParameter, onAdd = _a.onAdd, intl = _a.intl;
    var enableRenamingProjectToWorkspace = model_1.useDashboardSelector(model_1.selectEnableRenamingProjectToWorkspace);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DropdownSectionHeader_1.DropdownSectionHeader, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "configurationPanel.drillIntoUrl.editor.identifierParametersSectionLabel" })),
        identifierParametersSection
            .filter(function (_a) {
            var placeholder = _a.placeholder;
            return placeholder !== model_1.DRILL_TO_URL_PLACEHOLDER.CLIENT_ID || enableClientIdParameter;
        })
            .filter(function (_a) {
            var placeholder = _a.placeholder;
            return placeholder !== model_1.DRILL_TO_URL_PLACEHOLDER.WIDGET_ID || enableWidgetIdParameter;
        })
            .filter(function (_a) {
            var placeholder = _a.placeholder;
            return placeholder !== model_1.DRILL_TO_URL_PLACEHOLDER.DATA_PRODUCT_ID ||
                enableDataProductIdParameter;
        })
            .filter(function (_a) {
            var placeholder = _a.placeholder;
            return placeholder !==
                (enableRenamingProjectToWorkspace
                    ? model_1.DRILL_TO_URL_PLACEHOLDER.PROJECT_ID
                    : model_1.DRILL_TO_URL_PLACEHOLDER.WORKSPACE_ID);
        })
            .map(function (_a) {
            var placeholder = _a.placeholder, titleIntlKey = _a.titleIntlKey;
            var title = intl.formatMessage({ id: titleIntlKey });
            return (react_1.default.createElement(Parameter_1.Parameter, { key: placeholder, name: title, detailContent: getDetailContent(placeholder, title), iconClassName: "gd-icon-sharp", onAdd: function () { return onAdd(placeholder); }, intl: intl }));
        })));
};
//# sourceMappingURL=IdentifierParametersSection.js.map